import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

/*✰⋆｡:ﾟ･*☽:ﾟ･⋆｡✰⋆｡:ﾟ･*☽:ﾟ･⋆｡✰⋆｡:ﾟ･*☽
https://sankoudesign.com/category/simple/
https://www.wakitaseikeigeka.com/physicalcare/
https://threetimescoffee.jp/
https://oishi-animalclinic.com/
https://dokodemo.app/ja/
https://www.shiroiya.com/
https://baas.minna-no-ginko.com/
放課後等デイサービス
https://hokago-miraie.com/
✰⋆｡:ﾟ･*☽:ﾟ･⋆｡✰⋆｡:ﾟ･*☽:ﾟ･⋆｡✰⋆｡:ﾟ･*☽*/